import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { ReportExplanation } from 'apps/wsg/src/app/admin/report-explanation/report-explanation';
import { CONNECTED_DIALOG_DATA } from '@morningstar/shared/ui-kit/connected-dialog';

@Component({
  selector: 'wsg-report-explanation-icon-dialog',
  templateUrl: './report-explanation-icon-dialog.component.html',
  styleUrls: ['./report-explanation-icon-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportExplanationIconDialogComponent {
  constructor(@Inject(CONNECTED_DIALOG_DATA) public reportExplanation: ReportExplanation) { }
}
